interface IScriptLoader {
  defer: boolean;
  async: boolean;
  src: string;
  delay?: number;
  onload?: () => void;
}

const loadScript = (script: IScriptLoader) => {
  if (typeof document !== 'undefined') {
    const element = document.createElement('script');
    element.src = script.src;
    element.defer = script.defer;
    element.async = script.async;
    if (script.onload) {
      element.onload = script.onload;
    }

    if (script.delay) {
      setTimeout(() => document.body.appendChild(element), script.delay);
    } else {
      document?.body.appendChild(element);
    }
  }
};

export default loadScript;
